import { createAction } from '../utils/reducer.utils';
import { TREND_TOOLTIP_ACTION_TYPES } from './trend-tooltip.types';

export const setTooltipXPos = (xPos) => {
    return createAction(TREND_TOOLTIP_ACTION_TYPES.SET_TOOLTIP_X_POS, xPos);
};

export const clearTooltipXPos = () => {
    return createAction(TREND_TOOLTIP_ACTION_TYPES.CLEAR_TOOLTIP_X_POS);
};